import {showNotificationAction, PERMISSIONS_VIOLATION_FOUND} from '../actions';
import {getIsPackageDeepLinking, getCurrentViewType} from '../selectors';
import {viewTypes} from '../../constants/view-types';
import {NotificationTypes, NotificationLevels} from '@adsk/bim360-matrix-react-notification-manager/es/helpers/consts';
import i18n from '../../utils/i18n';
import lodashGet from 'lodash/get';

const dispatchNotificationAction = store => {
  store.dispatch(
    showNotificationAction({
      type: NotificationTypes.SNACKBAR,
      level: NotificationLevels.ERROR,
      message: i18n.t('permissionsErrors.notificationMessage')
    })
  );
};

export default () => store => next => action => {
  const state = store.getState();
  const isDeepLinking = getIsPackageDeepLinking(state) || lodashGet(action, 'meta.isDeepLinking');
  const viewType = getCurrentViewType(state);
  let hasGrowled = false;
  switch (action.type) {
    case PERMISSIONS_VIOLATION_FOUND: {
      // TODO: BTLV-7864 - Once viewType is properly handled for issueDetailsModal we need to verify that this actually works (should work out of the box unless viewType structure changes (e.g subViewType)).
      if (isDeepLinking || viewType === viewTypes.ISSUE_DETAILS_MODAL) {
        dispatchNotificationAction(store);
        hasGrowled = true;
      }
      action.meta = Object.assign({}, action.meta, {hasGrowled});
      break;
    }
    default:
      break;
  }
  return next(action);
};
